import React from "react";
import { NavLink } from "react-router-dom";

function OffersActions() {
  return (
    <nav className="uk-position-relative" aria-label="Breadcrumb">
      <ul className="uk-breadcrumb">
        <li>
          <NavLink to="/Cars">السيارات</NavLink>
        </li>
        <li>
          <span aria-current="page">عروض السيارات</span>
        </li>
      </ul>
      <NavLink
        to="/Offers/AddOffer"
        className="uk-button uk-button-primary uk-button-small uk-border-rounded uk-position-left"
      >
        <span className="uk-margin-small-left" uk-icon="plus"></span>
        إنشاء
      </NavLink>
    </nav>
  );
}

export default OffersActions;
